import type { Query } from "@material-table/core";

import type { OrderingSchema } from "./types";

export function forceString(value: any) {
  if (typeof value === "string") {
    return value;
  }
  return JSON.stringify(value);
}

export function createOrderingParams<T extends object>(
  query: Query<T>
): OrderingSchema | null {
  if (!query?.orderBy || !query?.orderBy?.field) {
    return null;
  }
  const order = {
    orderDirection: query.orderDirection,
    column: forceString(query.orderBy.field),
  };
  return { fields: [order] };
}
